import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
  customer_request_printHouse,
  messageClear,
  customer_update,
} from '../../store/reducers/authReducer'
import toast from 'react-hot-toast'
import { useState } from 'react'

const Profile = () => {
  const { t } = useTranslation()
  // const currentLanguage = i18n.language
  // const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const dispatch = useDispatch()
  const { userInfo, successMessage, errorMessage, loader } = useSelector(
    (state) => state.auth
  )

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    address: '',
    role: userInfo?.role || '',
    userType: userInfo?.userType || '',
    gender: '',
    printHouseName: '',
  })

  useEffect(() => {
    if (userInfo) {
      setFormData({
        name: userInfo?.name || '',
        phone: userInfo?.phone || '',
        address: userInfo?.address || '',
        role: userInfo?.role || '',
        userType: userInfo?.userType || '',
        gender: userInfo?.gender || '',
        printHouseName: userInfo?.printHouseName || '',
      })
    }
  }, [userInfo])

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const send_request = (e) => {
    e.preventDefault()
    dispatch(
      customer_request_printHouse({
        customerId: userInfo.id,
        userType: 'printHouse',
      })
    )
  }

  const submit = async (e) => {
    e.preventDefault()

    if (userInfo) {
      const obj = {
        name: formData.name,
        phone: formData.phone,
        address: formData.address,
        role: userInfo.role, // keep role from current userInfo
        gender: formData.gender,
        printHouseName: formData.printHouseName,
        customerId: userInfo.id,
      }

      dispatch(customer_update(obj))
    }
  }

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage)
      dispatch(messageClear())
    }
    if (errorMessage) {
      toast.error(errorMessage)
      dispatch(messageClear())
    }
  }, [successMessage, errorMessage])

  return (
    <div className="p-4 bg-white">
      <h2 className="text- font-bold text-slate-600 pb-5">
        {t('dashboardS.profile')}
      </h2>

      <div className="flex flex-row lg:flex-col gap-6">
        {/* Left: Form */}
        <form onSubmit={submit} className="flex-1">
          <div className="flex flex-col gap-1 mb-2">
            <label htmlFor="name">{t('home.name')}</label>
            <input
              className="outline-none px-3 py-1 border rounded-md text-slate-600"
              type="text"
              name="name"
              id="name"
              autoComplete="name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="flex flex-col gap-1 mb-2">
            <label htmlFor="phone">{t('home.phone')}</label>
            <input
              className="outline-none px-3 py-1 border rounded-md text-slate-600"
              type="text"
              name="phone"
              id="phone"
              autoComplete="phone"
              defaultValue={formData.userType}
              readOnly
            />
          </div>

          <div className="flex flex-col gap-1 mb-2">
            <label htmlFor="address">{t('home.address')}</label>
            <input
              className="outline-none px-3 py-1 border rounded-md text-slate-600"
              type="text"
              name="address"
              id="address"
              autoComplete="address"
              value={formData.address}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col gap-1 mb-2">
            <label htmlFor="gender">{t('home.gender')}</label>
            <input
              className="outline-none px-3 py-1 border rounded-md text-slate-600"
              type="text"
              name="gender"
              id="gender"
              value={formData.gender}
              onChange={handleChange}
            />
          </div>

          <div className="flex flex-col gap-1 mb-2">
            <label htmlFor="user_type">{t('home.user_type')}</label>
            <input
              className="outline-none px-3 py-1 border rounded-md text-slate-600"
              type="text"
              disabled
              name="user_type"
              id="user_type"
              defaultValue={formData.userType}
              readOnly
            />
          </div>
          {userInfo?.userType === 'printHouse' && (
            <div className="flex flex-col gap-1 mb-2">
              <label htmlFor="print_house"> {t('home.printHouse_name')}</label>
              <input
                className="outline-none px-3 py-1 border rounded-md text-slate-600"
                type="text"
                name="print_house"
                id="print_house"
                value={formData.printHouseName}
                onChange={handleChange}
              />
            </div>
          )}

          <div>
            <button
              type="submit"
              className="px-8 py-2 bg-[#059473] shadow-lg hover:shadow-green-500/30 text-white rounded-md"
            >
              Update Profile
            </button>
          </div>
        </form>

        {/* Right: Print House Button */}
        <div className="flex-1 flex items-start lg:items-center justify-center">
          <button
            onClick={send_request}
            disabled={userInfo.userType === 'printHouse'}
            className={`px-6 py-3 text-white rounded-md shadow ${
              loader || (userInfo && userInfo.userType === 'printHouse')
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-primary hover:shadow-blue-300/40'
            }`}
          >
            {loader ? 'Sending...' : t('home.requset_shop')}
          </button>

          {/* <button onClick={send_request} className="px-6 py-3 bg-primary text-white rounded-md shadow hover:shadow-blue-300/40">
       {t('home.requset_print_house')}
      </button> */}
        </div>
      </div>
    </div>
  )
}

export default Profile
